import { useState, useEffect, useCallback } from 'react';
import { tobaccoProducts } from 'services';
import { CONTAINERS } from 'pages/shared';
import { skeletonFactory, useHandleRequest, useAzureStorage } from 'shared';

const productDummy = skeletonFactory.tobaccoProduct();

export function useTobaccoProduct(id) {
  const [productData, setProductData] = useState(id ? productDummy : {});
  const { request, errorInfo, setErrorInfo } = useHandleRequest();
  const { readSasToken, getReadSasToken } = useAzureStorage(CONTAINERS.TOBACCO_PRODUCTS);

  useEffect(() => {
    async function getData() {
      await request(async () => {
        const response = await tobaccoProducts.getById(id);
        if (response) {
          setProductData(response.data || {});
        }
      }, false);
    }
    id && getData();
    !id && getReadSasToken();
  }, [request, id, getReadSasToken]);

  useEffect(() => {
    if (readSasToken) {
      setProductData(prev => ({ ...prev, readToken: readSasToken }));
    }
  }, [readSasToken]);

  const updateProduct = useCallback(
    async product => {
      await request(async () => {
        setProductData(product);
        await tobaccoProducts.update(id, product);
      });
    },
    [request, id]
  );

  const createProduct = useCallback(
    async product => {
      await request(async () => {
        setProductData(product);
        await tobaccoProducts.create(product);
      });
    },
    [request]
  );

  return {
    product: productData,
    errorInfo,
    setErrorInfo,
    setProductData,
    createProduct,
    updateProduct
  };
}
